<template>
	<div class="quick-phrases">
		<div class="quick-phrases-title">
			快捷短语
		</div>
		<ul class="quick-phrases-list">
			<li v-for="(item,index) in phrasesList" :key="index" @click="sendQuickPhrases(item.content)" @contextmenu.prevent="delQuickPhrases(item.id)"
			 class="quick-phrases-item">
				{{item.content}}
			</li>
		</ul>
		<div class="quick-foot">
			<i class="el-icon-plus" @click="openDialog"></i>
			<span class="foot-add">新建短语</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'QuickPhrases',
		data() {
			return {
				phrasesList: [], //短语数组
				friend_id:'',
				store_id:'',//店铺id
			}
		},
		props: {
			User_code: String,
			msgkey:String,
			chatList:Array,
		},
		methods: {
			async loadQuickPhrases() {
				var res = await this.$axios.post('/iMessage/loadQuickPhrases', {
					User_code: this.User_code
				})
				// console.log(res.data)
				if (res.data.done) {
					this.phrasesList = res.data.data
				} else {
					this.$message.error(res.data.msg)
				}
			},
			delQuickPhrases(id) {
				var that = this
				// 准备删除快捷短语
				that.$confirm('是否删除该快捷短语?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(async function(){
					var res = await that.$axios.post('/iMessage/delQuickPhrases', {
						id: id
					});
					that.loadQuickPhrases();
				})
			},
			sendQuickPhrases(data) {
				var that = this
				var bild = '{"type":"say","fromid":"' + this.User_code + '","toid":"' + this.friend_id +
					'","msgtype":"0","chat_type":"2","data":"' + data + '","msgkey":"' + this.msgkey +
					'","loginType":"pc","onlineType":"pc","store_id":"' + this.store_id + '"}';
				console.log(bild)
				this.$http.send(bild)
			},
			openDialog() {
				this.$emit('openDialog')
			}
		},
		created() {
			this.loadQuickPhrases();
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.quick-phrases-title {
		height: 45px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #fff;
		color: #333;
		font-size: 18px;
		border: 1px solid #eee;
		box-sizing: border-box;
	}

	.quick-phrases-list {
		width: 100%;
		height: calc(100% - 87px);
		box-sizing: border-box;
		margin: 0;
		list-style: none;
		overflow-y: auto;
		padding: 0;
		background-color: #eee;
	}

	.quick-phrases-item {
		list-style: none;
		width: 100%;
		box-sizing: border-box;
		padding-left: 24px;
		height: 32px;
		line-height: 32px;
		font-size: 12px;
		height: auto;
		color: #333;
		cursor: default;
		line-height: 20px;
		margin-bottom: 10px;
	}

	.quick-phrases-item:nth-child(odd) {
		background-color: #fff;
	}

	.quick-foot {
		width: 100%;
		height: 42px;
		line-height: 42px;
		padding-left: 24px;
		background-color: #fff;
		box-sizing: border-box;
		font-size: 16px;
	}

	.el-icon-plus {
		padding-right: 10px;
	}
</style>
